import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Divider, Skeleton, Stack, Typography } from '@mui/material'
import type { FC, PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { type To } from 'react-router'

import { COLORS, ICONS, rotateYCss, unit } from '@hcr/ui'

import { SvgLogoHolidayClub } from '../../../../../assets'
import { LayoutBase } from '../../../../common'
import { TicketValidityActive } from '../ticket-validity-active'

import {
  LayoutTicketDetailsActiveContainer,
  LayoutTicketDetailsActiveContent,
  LayoutTicketDetailsActiveHeader,
  LayoutTicketDetailsActiveHeaderContent,
  LayoutTicketDetailsActiveArrowLinkIcon,
  LayoutTicketDetailsActiveInfo,
  LayoutTicketDetailsActiveInfoContent,
  LayoutTicketDetailsActiveName,
  LayoutTicketDetailsActiveInfoContentSection,
  LayoutTicketDetailsActiveFooter,
} from './LayoutTicketDetailsActiveComponents'

interface LayoutTicketDetailsActiveLoadingProps extends PropsWithChildren {
  backNavigationPath: To
}

export const LayoutTicketDetailsActiveLoading: FC<LayoutTicketDetailsActiveLoadingProps> = ({ backNavigationPath }) => {
  const { t } = useTranslation()

  return (
    <LayoutBase>
      <LayoutTicketDetailsActiveContainer>
        <LayoutTicketDetailsActiveContent>
          <LayoutTicketDetailsActiveHeader as='header'>
            <LayoutTicketDetailsActiveHeaderContent>
              <LayoutTicketDetailsActiveArrowLinkIcon to={backNavigationPath} aria-label={t('tickets.back-to-booking')}>
                <FontAwesomeIcon icon={ICONS.farArrowLeft} />
              </LayoutTicketDetailsActiveArrowLinkIcon>
              <Stack alignItems='center' css={rotateYCss}>
                <Box marginBottom={unit(3)}>
                  <Skeleton width={unit(6.5)} height={unit(6.5)} sx={{ bgcolor: COLORS.white }} variant='rectangular' />
                </Box>
                <Typography variant='headlineL' color={COLORS.white} marginTop={unit(3)}>
                  <Skeleton width={unit(40)} height={unit(6)} sx={{ bgcolor: COLORS.white }} />
                </Typography>
                <SvgLogoHolidayClub height={unit(2)} fill={COLORS.white} />
              </Stack>
            </LayoutTicketDetailsActiveHeaderContent>
          </LayoutTicketDetailsActiveHeader>
          <LayoutTicketDetailsActiveInfo as='main'>
            <LayoutTicketDetailsActiveInfoContent>
              <LayoutTicketDetailsActiveName>
                <Skeleton width={unit(20)} height={unit(6)} sx={{ bgcolor: COLORS.grey }} />
              </LayoutTicketDetailsActiveName>
              <LayoutTicketDetailsActiveInfoContentSection>
                <Skeleton width={unit(40)} height={unit(6)} sx={{ bgcolor: COLORS.grey }} />
              </LayoutTicketDetailsActiveInfoContentSection>
              <TicketValidityActive>
                <Skeleton width={unit(60)} height={unit(16)} sx={{ bgcolor: COLORS.semantic.infoBodyDark }} />
              </TicketValidityActive>
            </LayoutTicketDetailsActiveInfoContent>
          </LayoutTicketDetailsActiveInfo>
        </LayoutTicketDetailsActiveContent>
        <LayoutTicketDetailsActiveFooter as='footer'>
          <Skeleton width={unit(40)} height={unit(6)} sx={{ bgcolor: COLORS.grey }} />
          <Skeleton width={unit(20)} height={unit(4)} sx={{ bgcolor: COLORS.grey }} />

          <Divider sx={{ borderStyle: 'dashed' }} />

          <Skeleton width={unit(40)} height={unit(6)} sx={{ bgcolor: COLORS.grey }} />
          <Skeleton width={unit(20)} height={unit(4)} sx={{ bgcolor: COLORS.grey }} />
        </LayoutTicketDetailsActiveFooter>
      </LayoutTicketDetailsActiveContainer>
    </LayoutBase>
  )
}
